import { Reducer, Action } from "redux";
import { IEducationState, KnownAction, RECEIVE_EDUCATION_DATA, SHOW_LOADER } from "./types";

export const reducer: Reducer<IEducationState> = (state: IEducationState | undefined, incomingAction: Action): IEducationState => {
    if (state === undefined) {
        return { educationData: [], isLoading: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_EDUCATION_DATA:
            return {
                ...state,
                educationData: action.educationData,
            };
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        default:
            return state;
    }
};
